module.exports = __webpack_public_path__ + "static/background-924ad141682413c307271131b2a706fb.jpg";